import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Logger } from "@timeghost/web-api";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

const log = new Logger("ErrorHandlerInterceptor");

/**
 * Adds a default error handler to all requests.
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
	constructor() {}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError((error) => this.errorHandler(error)));
	}

	// Customize the default error handler here if needed
	private errorHandler(response: HttpErrorResponse): Observable<HttpEvent<any>> {
		if (response.error instanceof Blob && response.status === 404) return;
		if (!environment.production) {
			// Do something with the error
			log.error("Request error", response);
		}
		throw response;
	}
}
